import React from "react";
import { Star } from "lucide-react";

/**
 * Calificación en estrellas, de 1 a 5.
 *
 * Una sola implementación para las dos superficies donde aparece: los
 * comentarios reales del home, sobre papel, y las voces de la promoción,
 * sobre el campo oscuro. Lo único que cambia es el color de la estrella
 * vacía — navy-200 sobre navy-800 no se ve — y el tamaño, porque junto a la
 * promoción el texto es más chico y una estrella de 16 px pesa más que la
 * frase que acompaña.
 *
 * `role="img"` con aria-label en el contenedor: cinco iconos sueltos se leen
 * como cinco imágenes sin nombre, y lo que hay que decir es "4 de 5".
 *
 * NO EMITE SCHEMA. Las estrellas son lo que el cliente puso en su entrega; un
 * `AggregateRating` en el marcado promedia esas notas y las publica como
 * calificación del negocio, y eso solo se hace con reseñas verificables.
 */
const Estrellas = ({ n, vacia = "text-navy-200", tamano = "h-4 w-4" }) => (
  <div className="flex gap-0.5" role="img" aria-label={`${n} de 5 estrellas`}>
    {[1, 2, 3, 4, 5].map((i) => (
      <Star
        key={i}
        className={`${tamano} ${i <= n ? "fill-sand-400 text-sand-400" : `fill-transparent ${vacia}`}`}
        aria-hidden="true"
      />
    ))}
  </div>
);

export default Estrellas;
